import { atom } from 'jotai';
import { DEFAULT_PAGINATION } from '@/common/pagination/types.ts';

export const locationPaginationAtom = atom(DEFAULT_PAGINATION);

export const resetLocationPaginationOnFilterChangeAtom = atom(null, (_get, set) => {
  set(locationPaginationAtom, DEFAULT_PAGINATION);
});
